module.exports = __webpack_public_path__ + "img/home_icon2_act.4f281e4d.png";